import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import ResetPasswordForm from "../../components/UI/Forms/Wizard Forms/LoginForm/ResetPasswordForm";
import SignUpGmtUserForm from "../../components/UI/Forms/Wizard Forms/LoginForm/SignUpGmtUserForm";
import { userActions } from "../../redux/reducers/UserReducer";
import store from "../../redux/Store";
import Icons from "../../resources/icons/Icons";
import Strings from "../../resources/Strings";
import Fonts from "../../resources/fonts/Fonts";
import * as actionsService from "../../services/ActionsService/ActionsService";
import MessageModal from "../../components/UI/Modals/MessageModal/MessageModal";
import classes from "./Login.module.css";

const SignUpNewGmtUser = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const contentParams = urlParams.get("content")?.replaceAll(" ", "+");
  const [validateError, setValidateError] = useState(false);
  const [invitationData, setInvitationData] = useState(false);

  useEffect(() => {
    store.dispatch(userActions.logout());
    if (contentParams) {
      actionsService
        .validateSignUpContent(contentParams)
        .then((response) => {
          if (response.data.isSuccess) {
            // let data = response.data.entity;
            // actionsService.getScopeByScopeId(data.scopeId)
            // .then((response) => {
            //   if (response.data.isSuccess) {
            //     let scopes = response.data.entity;
            //     actionsService.getUserSites()
            //     .then(response => {
            //       if (response.data.isSuccess) {
            //         let sites = response.data.entity;
            //         let selectedSites = sites.filter(site => scopes.some(scope => scope.Id === site.scopeId));
            //         data = {...data, selectedSites: selectedSites};
            //       }
            //     }).catch( err => {
            //       console.log("Get sites failed");
            //     });
            //   }
            // }).catch(err => {
            //   console.log("Get scopes failed");
            // }); 
            setInvitationData(response.data.entity);
            setValidateError(false);
          } else {
            setValidateError(true);
          }
        })
        .catch((error) => { });
    }
  }, [contentParams]);


  return (
    <div className={classes.loginPage}>
      <Grid classes={{ root: classes.root }} container>
        <Grid item className={classes.formGrid}>
          <div className={classes.formContainer}>
            <img className={classes.logoImg} src={Icons.LOGIN_LOGO}></img>
            {!validateError && <SignUpGmtUserForm invitationData={invitationData}/>}
            {validateError && (
              <>
                <div style={{ flexDirection: 'column', textAlign: 'center' }}>
                  <h2 style={{fontFamily: Fonts.ROBOTO_BOLD}}>{Strings.INVITATION_URL_EXPIRED_HEADER}</h2>
                  <div style={{fontFamily: Fonts.ROBOTO_REGULAR}}>{Strings.INVITATION_URL_EXPIRED_DESCRIPTION}</div>
                </div>
              </>
            )}
          </div>
        </Grid>
        <Grid item className={classes.imgGrid}>
          <div className={classes.imgContainer}>
            <div className={classes.divTest}>
              <img
                className={classes.image}
                src={Icons.SIGNUP_CAR}
              ></img>
            </div>
          </div>
        </Grid>
      </Grid>
      <MessageModal/>
    </div>
  );
};

export default SignUpNewGmtUser;
